/*@flow*/
import * as I from 'immutable';
import { Map } from 'immutable';

// TODO: test
//
// skipNulls
//
// Input: Map {a: {v: null, c: 1, d: {}}}
// Output: Map {a: {c: 1}}

const skipNulls = (m: Map<*, *>): any | Map<mixed, mixed> => m.map
    ? (m: any)
        .map(v =>
          I.isCollection(v)
            ? typeof v === 'object'
              ? v.isEmpty()
                ? null
                : skipNulls(v.filter(v2 => Boolean(v2)))
              : v
            : v
        )
        .filter(v =>
          I.isCollection(v) && typeof v === 'object' && v
            ? !v.isEmpty()
            : Boolean(v)
        )
    : m;
export default skipNulls;
